<div class="single-chart" > 
    <svg viewBox="0 0 36 36" class="circular-chart" [ngClass]="color">
        <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
        <path class="circle" [attr.stroke-dasharray]="progressValue+',100'" stroke-dasharray="0, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <text x="18" y="20" class="percentage english_stage_1-font">{{firstLine}}</text>
        <text *ngIf="secondLine" x="19" y="26" class="percentage english_stage_1-font" class="second-line" >{{secondLine}}</text>
      </svg>
  </div>